// test

import React, { Suspense, useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  FaCertificate,
  FaCheckCircle,
  FaClock,
  FaExclamationCircle,
  FaUserCheck,
} from 'react-icons/fa'

import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardImg,
  CardTitle,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  ListGroupItem,
  Progress,
  Row,
  Spinner,
  UncontrolledDropdown,
} from 'reactstrap'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCircleCheck,
  faCopy,
  faEllipsis,
  faL,
  faPenToSquare,
  faReorder,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons'

import { getExemptCourses } from 'store/EmployeeReport/actions'
import {
  fetchGroups,
  fetchGroupsCourses,
  toggleGroupOrder,
  fetchUserGroupProgress,
} from 'store/Group/actions'
import {
  progress,
  resetCourse,
  fetchUserProgress,
  deleteCourse,
  setCourseViewPermission,
  cloneCourse,
} from 'store/Course/actions'
import {
  setSearchByGroups,
  setSearchByCourses,
} from 'store/LearningPlan/actions'

import DefaultImage from 'assets/img/default-image.png'
import ReorderItems from './Reorder'
import { setIndividualCourses } from 'store/Group/actions'
import { fetchCourses } from 'store/Course/actions'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import Select from '../Group/Select'
import { selectRole } from 'store/LearningPlan/actions'
import { fetchRoles } from 'store/LearningPlan/actions'
import AxiosInstance from 'utils/AxiosInstance'
import Loader from '../Loader'
import './style.css'
import '../../../assets/css/Global/style.css'
import { setLastPathname } from 'store/Course/actions'
import { setGroupSearch } from 'store/LearningPlan/actions'
import { p, pre } from 'react-dom-factories'
import { motion, AnimatePresence } from 'framer-motion'

const DefaultSlider = React.lazy(() => import('./Slider'))

function millisecondsToHoursMinutes(milliseconds) {
  var seconds = milliseconds / 1000

  var hours = Math.floor(seconds / 3600)

  var remainingSeconds = seconds % 3600

  var minutes = Math.floor(remainingSeconds / 60)

  return `${hours}h, ${minutes}m`
}

function getColor(percentage) {
  if (percentage <= 25) {
    return 'red'
  } else if (percentage <= 50) {
    return 'orange'
  } else if (percentage <= 75) {
    return 'blue'
  } else {
    return 'green'
  }
}

const hasIntersect = (arr1, arr2) => {
  if (Array.isArray(arr1) && Array.isArray(arr2)) {
    for (var i = 0; i < arr1.length; i++) {
      for (var k = 0; k < arr2.length; k++) {
        if (arr1[i].includes(arr2[k])) {
          return true
        }
      }
    }
  }
  return false
}

function LearningPlan(props) {
  const groups = useSelector((state) => state.groups)
  const coursesState = useSelector((state) => state.courses)
  const employeeReport = useSelector((state) => state.employeeReport)
  const courseConfig = useSelector((state) => state.courseConfig)
  const { user, sidebarShowing } = useSelector((state) => state.auth)
  const location = useLocation()

  console.log(coursesState, 'leart129')

  const language = useSelector((state) => state.language)

  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const xlConditional =
    sidebarShowing && windowWidth >= 1200 && windowWidth <= 1365

  const [searchValueOnClick, setSearchValueOnClick] = useState('')

  const learningPlan = useSelector((state) => state.learningPlan)
  const dispatch = useDispatch()

  const [foundedCourses, setFoundedCourses] = useState([])

  // console.log(foundedCourses, 'leart142')

  const [inProgressClicked, setInProgressClicked] = useState(true)
  const [certifiedClicked, setCertifiedClicked] = useState(false)
  // const [failedClicked, setFailedClicked] = useState(false)
  const [needsManagerApprovalClicked, setNeedsManagerApprovalClicked] =
    useState(false)

  const [tagsStatus, setTagsStatus] = useState({
    inProgress: inProgressClicked,
    needsManagerApproval: needsManagerApprovalClicked,
    certified: certifiedClicked,
  })

  const [openedTags, setOpenedTags] = useState(null)

  // This state allows/disallows the layout of the status tags to change
  // depending on how much free space there is for the tags
  const [canTagLayoutChange, setCanTagLayoutChange] = useState(false)

  const cardHeader = useRef(null)
  const [cardHeaderWidth, setCardHeaderWidth] = useState(0)
  const [maxOpenedTagsBeforeLayoutUpdate, setMaxOpenedTagsBeforeLayoutUpdate] =
    useState(null)

  // This useEffect is responsible for dynamically changing the layout of the status tags
  // depending on the cardHeader width and the amount of opened tags
  useEffect(() => {
    const el = cardHeader.current
    if (!el) return

    const observer = new ResizeObserver(([entry]) => {
      const widthPx = Math.round(entry.contentRect.width)
      setCardHeaderWidth(widthPx)

      setCanTagLayoutChange(
        widthPx >= 50 && widthPx <= 950 && !(widthPx >= 600 && widthPx <= 870),
      )

      setMaxOpenedTagsBeforeLayoutUpdate(
        widthPx > 430 && !(widthPx >= 1055 && widthPx <= 1170) ? 3 : 2,
      )
    })

    observer.observe(el)

    return () => observer.disconnect()
  }, [])

  // Responsible for tracking the state of each status tag
  useEffect(() => {
    setTagsStatus((prev) => ({
      ...prev,
      inProgress: inProgressClicked,
      needsManagerApproval: needsManagerApprovalClicked,
      certified: certifiedClicked,
    }))
  }, [inProgressClicked, needsManagerApprovalClicked, certifiedClicked])

  // Responsible for tracking how many tags are opened
  // We need this for fixing overflow when the amount of tags opened causes overflow
  useEffect(() => {
    const count = Object.values(tagsStatus).filter(Boolean).length
    setOpenedTags(count)
  }, [tagsStatus])

  useEffect(() => {
    dispatch(setLastPathname(location.pathname))
  }, [])

  const roleGroups = (item) => {
    let value
    if (!learningPlan.selectedRole) {
      value = true
    } else {
      value = false
    }
    // let value = true

    if (
      learningPlan &&
      learningPlan.roleGroups &&
      learningPlan.roleGroups.length > 0
    ) {
      const index = learningPlan.roleGroups.findIndex(
        (group) => group.group_id == item.id,
      )

      index > -1 ? (value = true) : (value = false)
    }

    return value
  }

  useEffect(() => {
    if (learningPlan.groupSearch) {
      setSearchValueOnClick(learningPlan.groupSearch)
    }

    return () => dispatch(setGroupSearch(''))
  }, [learningPlan.groupSearch, dispatch])

  // useEffect(() => {
  //   let userGroupsCourses = groups.userGroupsCourses
  //   let learningPlanGroups = groups.learningPlanGroups
  //   let courses = coursesState?.courses
  //   let courseIds = courses
  //     .filter((course) =>
  //       course.name.toLowerCase().includes(searchValueOnClick.toLowerCase())
  //     )
  //     .map((course) => course.id)

  //   console.log('150', userGroupsCourses)

  //   let foundedCourses = []

  //   for (let groupCourse of userGroupsCourses) {
  //     if (courseIds.includes(groupCourse.course_id)) {
  //       let group = learningPlanGroups.find(
  //         (group) => group.id === groupCourse.group_id
  //       )
  //       let course = courses.find(
  //         (course) => course.id === groupCourse.course_id
  //       )
  //       foundedCourses.push({ ...groupCourse, group, course })
  //     }
  //   }

  //   setFoundedCourses(foundedCourses)
  // }, [searchValueOnClick])

  useEffect(() => {
    const individualCoursesIds = groups.individualCourses.map(
      (individualCourse) => individualCourse.course_id,
    )

    let initialUserGroupsCoursess = groups.userGroupsCourses
    const individualCourses = individualCoursesIds.map((iC) => {
      return { course_id: iC, group_id: null, position: null }
    })

    const userGroupsCourses = [
      ...initialUserGroupsCoursess,
      ...individualCourses,
    ]

    let learningPlanGroups = groups.learningPlanGroups
    let courses = coursesState?.courses
    let courseIds = courses
      .filter((course) => {
        // keywords can be null for courses that have none
        let keywords = (course.keywords || []).map(
          (keyword) => keyword && keyword.toLowerCase(),
        )
        keywords =
          keywords && keywords.length && keywords.filter((k) => Boolean(k))

        return (
          (course.name || '')
            .toLowerCase()
            .includes(searchValueOnClick.toLowerCase()) ||
          hasIntersect(keywords, searchValueOnClick.toLowerCase().split(' '))
        )
      })
      .map((course) => course.id)

    let foundedCourses = []
    let uniqueCourseIds = new Set()

    for (let groupCourse of userGroupsCourses) {
      if (
        courseIds.includes(groupCourse.course_id) &&
        !uniqueCourseIds.has(groupCourse.course_id)
      ) {
        let group = learningPlanGroups.find(
          (group) => group.id === groupCourse.group_id,
        )
        let course = courses.find(
          (course) => course.id === groupCourse.course_id,
        )
        foundedCourses.push({ ...groupCourse, group, course })
        uniqueCourseIds.add(groupCourse.course_id)
      }
    }

    setFoundedCourses(foundedCourses)
  }, [searchValueOnClick])

  useEffect(() => {
    dispatch(fetchGroups())
    dispatch(fetchCourses(true))
    dispatch(fetchGroupsCourses())
    dispatch(fetchUserGroupProgress())
    dispatch(fetchUserProgress())
    // dispatch(progress())
    dispatch(getExemptCourses(user?.id))
    setTimeout(() => {
      dispatch(setIndividualCourses())
    }, 2000)
  }, [user?.id])

  useEffect(() => {
    // Update window width on resize
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    dispatch(fetchRoles())
  }, [dispatch])

  // const updateScreenSize = () => {
  //  if (window.innerWidth >= 13 * window.devicePixelRatio) {
  //    setScreenSize('lg')
  //  } else {
  //    setScreenSize('xl')
  //  }
  // }

  let blurClasses = ''
  if (
    courseConfig &&
    user?.access !== 1 &&
    courseConfig.enableReorderCourseGroup != NaN &&
    courseConfig.enableReorderCourseGroup === 1
  ) {
    blurClasses = ' blur-hover'
  }

  const firstReorderElement = groups.learningPlanGroups.find(
    (group) => group.status !== 4,
  )

  // This boolean checks if the current state of the page meets the conditions
  // to allow layout change on the status tags
  const shouldBeGrid =
    openedTags >= maxOpenedTagsBeforeLayoutUpdate && canTagLayoutChange

  return (
    <Container className='mt--6' fluid>
      <Card className='overflow-hidden' style={{ minHeight: '85vh' }}>
        <div ref={cardHeader}>
          <CardHeader className='border-0'>
            <Row className='justify-content-center justify-content-md-end pb-3  pr-0  px-0 px-md-2 position-relative'>
              <Col
                lg='12'
                xl={xlConditional ? '12' : '12'}
                className='pr-0 px-0 d-flex  '
              >
                <Row className='col-md-12 px-0 justify-content-lg-between justify-content-center'>
                  <Col
                    style={{
                      display: shouldBeGrid ? 'grid' : 'flex',
                      gridAutoRows: 'min-content',

                      gridTemplateColumns:
                        cardHeaderWidth > 370 ? '1fr 1fr' : '1fr',
                      gap: '6px',
                      marginLeft: '16px',
                      zIndex: 10,
                    }}
                    className='statuses-container'
                    lg='3'
                    xl={xlConditional ? '3' : '2'}
                  >
                    {!inProgressClicked ? (
                      <motion.div
                        layout
                        role='button'
                        onClick={() => setInProgressClicked(!inProgressClicked)}
                        className='card-certified text-center align-items-center d-flex bg-success text-white text-nowrap mr-2'
                        style={{ height: '1.8rem' }}
                        transition={{ duration: 0.25, ease: 'easeInOut' }}
                      >
                        <FontAwesomeIcon icon={faCircleCheck} />
                      </motion.div>
                    ) : (
                      <motion.div
                        layout
                        role='button'
                        onClick={() => setInProgressClicked(!inProgressClicked)}
                        className='card-certified text-center align-items-center d-flex bg-success text-white text-nowrap mr-2'
                        style={{ height: '1.8rem' }}
                        transition={{ duration: 0.25, ease: 'easeInOut' }}
                      >
                        {lang[1]?.map((item, index) => (
                          <span key={index} className='certified-status'>
                            {item}
                          </span>
                        ))}
                      </motion.div>
                    )}

                    {/* Needs Manager Approval */}
                    {!needsManagerApprovalClicked ? (
                      <motion.div
                        layout
                        role='button'
                        onClick={() =>
                          setNeedsManagerApprovalClicked(
                            !needsManagerApprovalClicked,
                          )
                        }
                        style={{
                          height: '1.8rem',
                          backgroundColor: 'rgb(0, 182, 237)',
                        }}
                        className='card-certified text-center align-items-center d-flex text-white text-nowrap mr-2'
                        transition={{ duration: 0.25, ease: 'easeInOut' }}
                      >
                        <FaUserCheck />
                      </motion.div>
                    ) : (
                      <motion.div
                        layout
                        role='button'
                        onClick={() =>
                          setNeedsManagerApprovalClicked(
                            !needsManagerApprovalClicked,
                          )
                        }
                        style={{
                          height: '1.8rem',
                          backgroundColor: 'rgb(0, 182, 237)',
                        }}
                        className='card-certified text-center align-items-center d-flex text-white text-nowrap mr-2'
                        transition={{ duration: 0.25, ease: 'easeInOut' }}
                      >
                        {lang[3]?.map((item, index) => (
                          <span key={index} className='certified-status'>
                            {item}
                          </span>
                        ))}
                      </motion.div>
                    )}

                    {/* Certified */}
                    {!certifiedClicked ? (
                      <motion.div
                        layout
                        role='button'
                        onClick={() => setCertifiedClicked(!certifiedClicked)}
                        style={{ height: '1.8rem' }}
                        className='card-certified text-center align-items-center d-flex bg-certified text-white mr-2'
                        transition={{ duration: 0.25, ease: 'easeInOut' }}
                      >
                        <FaCertificate />
                      </motion.div>
                    ) : (
                      <motion.div
                        layout
                        role='button'
                        onClick={() => setCertifiedClicked(!certifiedClicked)}
                        style={{ height: '1.8rem' }}
                        className='card-certified text-center align-items-center d-flex bg-certified text-white mr-2'
                        transition={{ duration: 0.25, ease: 'easeInOut' }}
                      >
                        {lang[4]?.map((item, index) => (
                          <span key={index} className='certified-status'>
                            {item}
                          </span>
                        ))}
                      </motion.div>
                    )}
                  </Col>
                  <div className='d-flex flex-column align-items-end'>
                    <Col
                      className='buttons px-0 pb-3 d-flex justify-content-center justify-content-md-start justify-content-lg-end'
                      lg='auto'
                      xl={xlConditional ? 'auto' : 'auto'}
                    >
                      {[1, 4].includes(user.access) ? (
                        <>
                          <div className='reorder-courses-wrapper  mr-1 mr-md-2'>
                            <Button
                              color='white'
                              size='sm'
                              className='border-none px-md-3 py-2 reorder-button'
                              onClick={() => dispatch(toggleGroupOrder())}
                            >
                              <FontAwesomeIcon
                                icon={faReorder}
                                className='btn-icon'
                              />
                              <span>
                                {language.language?.data.general.reorder}
                              </span>
                            </Button>
                            {groups.groupOrderShowing ? (
                              <ReorderItems
                                {...props}
                                user={user}
                                coursesState={coursesState}
                                groups={groups}
                              />
                            ) : null}
                          </div>
                          <Link
                            to={`/group/new?from=learning-plan`}
                            style={{ color: '#172b4d' }}
                            className='mr-1 mr-md-2'
                          >
                            <Button
                              color='white'
                              className='border-none px-md-3 py-2'
                              size='sm'
                            >
                              <i class='btn-icon pr-2 fas fa-plus '></i>
                              {
                                language.language?.data.learning_plan
                                  .new_course_group
                              }
                            </Button>
                          </Link>
                          <Link
                            to='/course/new'
                            style={{ color: '#172b4d' }}
                            className=''
                          >
                            <Button
                              color='white'
                              className='border-none px-md-3 py-2'
                              size='sm'
                              type='button'
                              onClick={() => dispatch(resetCourse())}
                            >
                              <i class='btn-icon pr-2 fas fa-plus '></i>
                              {language.language?.data.learning_plan.new_course}
                            </Button>
                          </Link>
                        </>
                      ) : null}
                    </Col>
                    <Col
                      xs='12' // full width on mobile
                      sm='12'
                      md='12' // 10/12 = ~83% on medium+
                      lg={user.access === 1 ? '8' : '12'}
                      xl={user.access === 1 ? '8' : '12'}
                      className='search-bar pl-0 pr-0 mr-0'
                    >
                      <FormGroup
                        className='mb-0 pb-1 custom-width ml-md-auto col-12 pr-0 search-bar-responsive'
                        // style={{ maxWidth: '100%' }}
                      >
                        <InputGroup>
                          <Input
                            placeholder={
                              learningPlan.searchByCourses &&
                              language.language?.data.learning_plan
                                ? language.language?.data.learning_plan
                                    .search_courses
                                : learningPlan.searchByGroups
                                  ? language.language?.data.groups
                                      .search_course_groups
                                  : null
                            }
                            onChange={(e) => {
                              setSearchValueOnClick(e.target.value)
                              if (searchValueOnClick?.length === 0) {
                                dispatch(setGroupSearch(''))
                              }
                            }}
                            defaultValue={searchValueOnClick}
                            type='text'
                            bsSize='sm'
                            style={{
                              padding: '18px',
                            }}
                          />
                          <InputGroupAddon addonType='append'>
                            <InputGroupText
                              style={{ backgroundColor: '#01A0F2' }}
                            >
                              <button
                                style={{
                                  fontSize: '15px',
                                  height: '10px',
                                }}
                                className='border-0 bg-transparent d-flex  justify-content-center align-items-center'
                              >
                                <i class='fas fa-search search-icon'></i>
                              </button>
                            </InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      </FormGroup>
                      <div className='d-flex justify-content-md-start custom-checkboxes justify-content-center col-12'>
                        <div className='custom-control custom-radio dashboard-radio mr-2'>
                          <input
                            className='custom-control-input bg-default'
                            checked={learningPlan.searchByGroups}
                            onChange={() => dispatch(setSearchByGroups())}
                            name='search-groups'
                            id='search-groups'
                            type='radio'
                          />
                          <label
                            className='custom-control-label'
                            style={{ paddingTop: '1px' }}
                            htmlFor='search-groups'
                          >
                            {language.language?.data.groups.groups}
                          </label>
                        </div>

                        <div className='custom-control custom-radio dashboard-radio mr-2'>
                          <input
                            className='custom-control-input bg-default'
                            checked={learningPlan.searchByCourses}
                            onChange={() => dispatch(setSearchByCourses())}
                            name='search-course'
                            id='search-course'
                            type='radio'
                          />
                          <label
                            className='custom-control-label'
                            style={{ paddingTop: '1px' }}
                            htmlFor='search-course'
                          >
                            {language.language?.data.groups.courses}
                          </label>
                        </div>
                      </div>
                    </Col>
                  </div>
                </Row>
              </Col>
            </Row>
            <Row className='select-job-role' style={{ marginTop: '10px' }}>
              <Col xs='11' sm='6' md='5' lg='3'>
                <div>
                  {(user.access === 1 || user.allow_switch_roles > 0) && (
                    <div style={{ marginLeft: '10px' }}>
                      <Select
                        options={learningPlan.roles}
                        selectedOptions={learningPlan.selectedRole}
                        onChange={(selectedRole) =>
                          dispatch(selectRole(selectedRole))
                        }
                        language={language}
                        placeholder='Select Job Role'
                        multi={false}
                      />
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </CardHeader>
        </div>

        {groups.locationsLoading ? (
          FallbackComp
        ) : (
          <CardBody className='p-0'>
            <Suspense fallback={FallbackComp}>
              {(() => {
                if (
                  learningPlan.searchByGroups === false &&
                  searchValueOnClick
                  // learningPlanGroups.length === 0
                ) {
                  return null
                } else
                  return groups.learningPlanGroups
                    .filter(
                      (item) =>
                        item.show_in_learning_plan &&
                        item.type === 'course' &&
                        item.name
                          .toLowerCase()
                          .indexOf(searchValueOnClick.toLowerCase()) !== -1 &&
                        roleGroups(item),
                    )
                    .map((group, index) => {
                      const groupCoursesData =
                        groups.groupsCourses[group.id] || []
                      const groupCourses = groupCoursesData.map(
                        (item) => item.course_id,
                      )

                      let courses = []

                      groupCourses.forEach(
                        (id) =>
                          (courses = [
                            ...courses,
                            ...coursesState.progress.filter(
                              (course) => course.id === id,
                            ),
                          ]),
                      )
                      courses = courses.filter((item) => {
                        const exemptCourses = employeeReport?.exemptCourses

                        if (!exemptCourses || !Array.isArray(exemptCourses)) {
                          return true
                        }

                        return !exemptCourses.find(
                          (exemptCourse) => exemptCourse.course_id === item.id,
                        )
                      })

                      return (
                        <>
                          {courses.length > 0 && (
                            <DefaultSlider
                              key={group.id}
                              sectionTitle={group.name}
                              id={group.id}
                              inactive={group.inactive}
                              access={user.access}
                              blurClasses={
                                props.access !== 1 &&
                                firstReorderElement &&
                                group.position !==
                                  firstReorderElement.position &&
                                group.status !== 4
                                  ? blurClasses
                                  : ''
                              }
                            >
                              {courses.length > 0
                                ? courses.map((course, courseIndex) => {
                                    const prevCourse = courses[courseIndex - 1]
                                      ? coursesState.userProgress.find(
                                          (item) =>
                                            item.course_id ===
                                            courses[courseIndex - 1].id,
                                        )
                                      : null

                                    return (
                                      <CourseDetails
                                        from={'learning-plan'}
                                        groupCourses={groupCoursesData}
                                        groupId={group.id}
                                        courseState={coursesState}
                                        course={course}
                                        user={user}
                                        groupOwner={group.owner}
                                        enableReorder={group.enable_reorder}
                                        key={courseIndex}
                                        index={courseIndex}
                                        courseIndex={courseIndex}
                                        courseConfig={courseConfig}
                                        prevCourse={prevCourse}
                                        setFoundedCourses={setFoundedCourses}
                                      />
                                    )
                                  })
                                : null}
                            </DefaultSlider>
                          )}
                        </>
                      )
                    })
              })()}
              {/*{learningPlan.searchByCourses ? (*/}
              {/*  searchValueOnClick && coursesState.progress.length > 0 ? (*/}
              {/*    <div className="row px-3 pb-4">*/}
              {/*      {coursesState.progress*/}
              {/*        .filter(*/}
              {/*          (item) =>*/}
              {/*            !employeeReport?.exemptCourses?.find(*/}
              {/*              (exemptCourse) => exemptCourse.course_id === item.id*/}
              {/*            )*/}
              {/*        )*/}
              {/*        .filter((item) => {*/}
              {/*          const courseKeywords =*/}
              {/*            (item.keywords &&*/}
              {/*              item.keywords.length &&*/}
              {/*              item.keywords.map((item) => item.toLowerCase())) ||*/}
              {/*            [];*/}
              {/*          return (*/}
              {/*            item.name &&*/}
              {/*            (item.name*/}
              {/*              .toLowerCase()*/}
              {/*              .indexOf(searchValueOnClick.toLowerCase()) !== -1 ||*/}
              {/*              hasIntersect(*/}
              {/*                courseKeywords,*/}
              {/*                searchValueOnClick.toLowerCase().split(" ")*/}
              {/*              ))*/}
              {/*          );*/}
              {/*        })*/}
              {/*        .map((item, courseIndex) => (*/}
              {/*          <div*/}
              {/*            className={`col-sm-6 col-lg-4 col-md-4 ${*/}
              {/*              windowWidth > 1500 ? "col-xl-3" : "col-xl-4"*/}
              {/*            } mb-5 `}*/}
              {/*            id="coursesOnSearch"*/}
              {/*          >*/}
              {/*            <CourseDetails*/}
              {/*              fromSearch={true}*/}
              {/*              courseState={coursesState}*/}
              {/*              key={item.course_id}*/}
              {/*              course={item}*/}
              {/*              user={user}*/}
              {/*              courseIndex={courseIndex}*/}
              {/*              courseConfig={courseConfig}*/}
              {/*            />*/}
              {/*          </div>*/}
              {/*        ))}*/}
              {/*    </div>*/}
              {/*  ) : null*/}
              {/*) : null}*/}
              {coursesState.courses.length === 0 && (
                <p style={{ justifySelf: 'center' }}>No courses to display.</p>
              )}
              {learningPlan.searchByCourses &&
              searchValueOnClick &&
              coursesState.progress.length > 0 ? (
                <div className='row px-3 pb-4'>
                  {foundedCourses?.map((item, index, courses) => {
                    const foundedProgress = coursesState.userProgress.find(
                      (progressItem) =>
                        progressItem?.course_id === item?.course_id,
                    )
                    const prevCourse = index > 0 ? foundedProgress : null
                    const groupCoursesData =
                      groups.groupsCourses[item?.group?.id] || []

                    return (
                      <div
                        className={`col-sm-6 col-lg-4 col-md-4 ${
                          windowWidth > 1500 ? 'col-xl-3' : 'col-xl-4'
                        } mb-5 `}
                        id='coursesOnSearch'
                      >
                        <CourseDetails
                          fromSearch={true}
                          courseState={coursesState}
                          groupCourses={groupCoursesData}
                          key={item?.course?.course_id}
                          course={item?.course}
                          groupId={item?.group?.id}
                          groupOwner={item?.group?.owner}
                          enableReorder={item?.group?.enable_reorder}
                          user={user}
                          courseIndex={index}
                          courseConfig={courseConfig}
                          prevCourse={prevCourse}
                          isSearch={searchValueOnClick}
                          setFoundedCourses={setFoundedCourses}
                        />
                      </div>
                    )
                  })}
                </div>
              ) : null}

              {learningPlan.searchByGroups === false &&
              !searchValueOnClick &&
              groups.allCourses &&
              groups.allCourses.length > 0 &&
              courseConfig.enableModuleAllCourses ? (
                <Suspense fallback={FallbackComp}>
                  <DefaultSlider
                    individual={true}
                    sectionTitle='Course Catalog'
                    key={'course-catalog'}
                  >
                    {groups.allCourses.length > 0
                      ? groups.allCourses.map((course, courseIndex) => {
                          return (
                            <CourseDetails
                              from={'learning-plan'}
                              key={course.course_id}
                              courseState={coursesState}
                              course={course}
                              user={user}
                              courseIndex={courseIndex}
                              courseConfig={courseConfig}
                              setFoundedCourses={setFoundedCourses}
                            />
                          )
                        })
                      : null}
                  </DefaultSlider>
                </Suspense>
              ) : null}

              {
                learningPlan.searchByGroups === false &&
                !searchValueOnClick &&
                groups?.individualCourses?.length > 0 ? (
                  <Suspense fallback={FallbackComp}>
                    <DefaultSlider
                      individual={true}
                      sectionTitle='Individual Courses'
                      key={'individual'}
                    >
                      {groups.individualCourses.length > 0
                        ? groups.individualCourses.map(
                            (course, courseIndex) => (
                              <CourseDetails
                                from={'learning-plan'}
                                key={course.course_id}
                                courseState={coursesState}
                                course={course}
                                user={user}
                                courseIndex={courseIndex}
                                courseConfig={courseConfig}
                                setFoundedCourses={setFoundedCourses}
                              />
                            ),
                          )
                        : null}
                    </DefaultSlider>
                  </Suspense>
                ) : null
                // <div className='dFlex itemsCenter justifyCenter' style={{ minHeight: "68vh" }}>
                //   <p className='text-primary blockquote font-weight-normal'>No Courses</p>
                // </div>
              }

              {/* {groups.locationsLoading ? FallbackComp : groups.learningPlanGroups.length === 0 && (
            <div className='text-center mt-5'>
              <h2>No Courses Assigned</h2>
            </div>
          )} */}

              {/* leon learning plan */}
              {/* {groups.locationsLoading
          ? FallbackComp
          : !groups.learningPlanGroups ?
            <div className='text-center mt-5'>
              <h2>No Courses Assigned</h2>
            </div>
            :
            null
        } */}

              {/* {groups.learningPlanGroups.length === 0 && (
            <div className='text-center mt-5'>
              <h2>No Courses Assigned</h2>
            </div>
          )} */}
            </Suspense>
          </CardBody>
        )}
      </Card>
    </Container>
  )
}
export default LearningPlan

export function CourseDetails(props) {
  const [showFullDescription, setShowFullDescription] = useState(false)
  const { coursesViewPermission } = useSelector((state) => state.courses)

  const language = useSelector((state) => state.language)

  const toggleShowFullDescription = (e) => {
    e.preventDefault()
    setShowFullDescription(!showFullDescription)
  }

  const dispatch = useDispatch()
  const [percentage, setPercentage] = useState(null)

  useEffect(() => {
    setPercentage(
      (props.course.finished_contents / props.course.content_count) * 100,
    )
  }, [props.course.finished_contents, props.course.content_count])

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const response = await AxiosInstance.get(
  //         `/courses/${props.course.id}/languages/1/contents`
  //       )
  //       const filteredSubtitles = response.filter(
  //         (content) => content.content[0].type !== '0'
  //       )
  //       setContentsLength(filteredSubtitles.length)
  //     } catch (error) {
  //       console.error('Error fetching data:', error)
  //     }
  //   }

  //   fetchData()
  // }, [props.course.id])

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const responseFinished = await AxiosInstance.get(
  //         `/users/self/course-content-finished/${props.course.id}`
  //       )

  //       setPercentage(
  //         (responseFinished.length / props.course.content_count) * 100
  //       )
  //     } catch (error) {
  //       console.error('Error fetching data:', error)
  //     }
  //   }

  //   fetchData()
  // }, [props.course.id, language?.language?.id, props.course.content_count])

  let allowCourseView = true
  if (
    props.user.access !== 1 &&
    props.enableReorder === 1 &&
    props.groupCourses &&
    props.groupCourses.find((item) => item.position !== '' && item.position > 0)
  ) {
    if (props.groupId) {
      if (props.index === 0) {
        allowCourseView = true
      } else if (props.prevCourse && props.prevCourse.status < 4) {
        allowCourseView = false
      } else if (!props.prevCourse) {
        allowCourseView = false
      }

      if (coursesViewPermission.has(Number(props.course_id))) {
        setCourseViewPermission(Number(props.course_id), allowCourseView)
      }
    }
  }

  const progressItem = props.courseState.userProgress.find(
    (item) => item.course_id === props.course.course_id,
  )

  const hasCourseStarted =
    progressItem &&
    progressItem.courseStarted &&
    progressItem.courseStarted === 1
      ? true
      : false

  const [isHovered, setIsHovered] = useState(false)

  const foundedStatus = props.courseState?.userProgress?.find(
    (item) => item.course_id === props.course?.course_id,
  )?.status

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return {
        truncatedDesc: `${text.slice(0, maxLength)}...`,
        canToggle: true,
      }
    }
    return {
      truncatedDesc: text,
      canToggle: false,
    }
  }

  const showCardDescription = (course, maxLength) => {
    const { truncatedDesc, canToggle } = truncateText(
      course.description || '...',
      maxLength,
    )

    const displayDescription =
      showFullDescription && canToggle ? course.description : truncatedDesc
    return (
      <>
        <div className={'px-2 py-1'}>
          {displayDescription}
          {canToggle && (
            <span
              className='view-more-less-text pl-1'
              style={{ fontSize: '12px' }}
              onClick={toggleShowFullDescription}
            >
              {showFullDescription ? 'View less' : 'View more'}
            </span>
          )}
        </div>
      </>
    )
  }

  const cardStatus = () => {
    const item = props.courseState.userProgress.find(
      (item) => item.course_id === props.course.id,
    )

    const timeToCertify = millisecondsToHoursMinutes(item?.certification_time)

    return (
      <div
        className={`card-certified ${getStatusClass(
          props.course.course_status,
        )}`}
      >
        {lang[foundedStatus]?.map((item, index) => {
          return (
            <span className={`certified-status`}>
              {lang[foundedStatus][index]}
            </span>
          )
        })}
        {item?.status > 0 && <span className='ml-3'>{timeToCertify}</span>}
      </div>
    )
  }

  return (
    <LazyLoadComponent>
      <Card
        // className="p-0 shadow learning-plan-card h-100"
        className='p-0 shadow learning-plan-card'
        key={props.course.course_id}
        style={
          props.fromSearch
            ? {
                marginBottom: '0',
              }
            : null
        }
      >
        <Link
          to={allowCourseView ? `/course/${props.course.course_id}` : '#'}
          style={{ height: '100%', display: 'block' }}
        >
          <div
            style={{
              // height: '14rem',
              filter: `blur(${allowCourseView ? 0 : '1.2px'})`,
              height: '70%',
            }}
            // onMouseEnter={() => setIsHovered(true)}
            // onMouseLeave={() => setIsHovered(false)}
            className={'card-image-box'}
          >
            <img
              aria-hidden='true'
              src={props.course.image ? props.course.image : DefaultImage}
              alt=''
              style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                filter: 'blur(14px)',
                transform: 'scale(1.15)',
              }}
            />
            <CardImg
              style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                zIndex: 1,
              }}
              alt='...'
              src={props.course.image ? props.course.image : DefaultImage}
              top
            />
            <div
              style={{
                position: 'absolute',
                bottom: 0,
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                color: '#fff',
                zIndex: 2,
              }}
            >
              {props.course.course_status !== 0 && cardStatus()}
              <div className={'card-content mb text-sm '}>
                {showCardDescription(props.course, 30)}
              </div>
            </div>
            {<div className={'img-overlay'}></div>}
          </div>

          <CardBody
            className='p-2 px-3 border-top course-details '
            style={{
              height: '30%',
              maxHeight: props.fromSearch ? '180px' : '160px',
              // overflow: "auto",
              backgroundColor: `${allowCourseView ? '#fff' : '#cfcfcf'}`,
            }}
          >
            <div
              className='d-flex flex-column justify-content-between pb-0'
              // style={{ height: '100%' }}
            >
              <div>
                <CardTitle
                  className=' d-flex justify-content-between learning-plan-title'
                  tag='h3'
                >
                  <span title={props.course.name} className='course-name'>
                    {props.course.name}
                  </span>
                  {props.user && props.user.access === 1 && (
                    <div className='d-md-block'>
                      <UncontrolledDropdown direction='left'>
                        <DropdownToggle
                          className='actionToggle'
                          role='button'
                          size='sm'
                          onClick={(e) => e.preventDefault()}
                        >
                          <FontAwesomeIcon icon={faEllipsis} size={'lg'} />
                        </DropdownToggle>
                        <DropdownMenu className='dropdown-menu-arrow course-dropdown'>
                          <Link
                            to={`/course/${props.course.course_id}/edit`}
                            className='edit-course-button'
                          >
                            <DropdownItem className='actionIcon actionIconEdit'>
                              <FontAwesomeIcon
                                icon={faPenToSquare}
                                className=' dropdown-item-icon'
                              />
                              {language.language
                                ? language.language.data.general.edit
                                : 'Edit'}
                            </DropdownItem>
                          </Link>
                          <DropdownItem
                            href='#pablo'
                            onClick={(e) => {
                              dispatch(cloneCourse(props.course.course_id))
                              e.preventDefault()
                            }}
                            className='actionIcon actionIconCopy copy-button'
                          >
                            <FontAwesomeIcon
                              icon={faCopy}
                              className='dropdown-item-icon'
                            />
                            {language.language
                              ? language.language.data.general.copy
                              : 'Copy'}
                          </DropdownItem>
                          <DropdownItem
                            onClick={(e) => {
                              props.setFoundedCourses((prev) =>
                                prev.filter(
                                  (c) => c.course_id !== props.course.course_id,
                                ),
                              )
                              dispatch(deleteCourse(props.course.course_id))
                              e.preventDefault()
                            }}
                            className='actionIcon actionIconDelete'
                          >
                            <FontAwesomeIcon
                              icon={faTrashAlt}
                              className='dropdown-item-icon'
                            />
                            {language.language
                              ? language.language.data.general.delete
                              : 'Delete'}
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  )}
                </CardTitle>
              </div>
              <Row
                className='justify-content-between '
                style={{ minHeight: '43px' }}
              >
                <Col className='course-infos d-flex align-items-center'>
                  {props.course.content_count > 0 && (
                    <h6
                      className='pr-3 text-nowrap pt-2  '
                      style={{ color: '#525F7F' }}
                    >
                      <i class='far fa-file pr-1'></i>
                      {props.course.content_count}{' '}
                      {props.course.content_count === 1 ? 'lesson' : 'lessons'}
                    </h6>
                  )}
                  {/* <h6 className='text-nowrap pt-2' style={{ color: '#525F7F' }}>
                    <i class='far fa-clock pr-1'></i>
                    5h 22m
                  </h6> */}
                </Col>
                {percentage > 0 && props.course.course_status !== 0 && (
                  <Col className='course-infos d-flex align-items-center'>
                    <div
                      className={`px-0 text-center text-${getColor(
                        percentage,
                      )}`}
                      // className={` text-center text-${getColor(percentage)}`}
                    >
                      {percentage <= 100 ? Math.floor(percentage) : 100}%
                    </div>
                    <div
                      className='col'
                      style={{ paddingRight: 0, paddingLeft: '7px' }}
                    >
                      <Progress
                        className='progress-xs mb-0'
                        color={getColor(percentage)}
                        max='100'
                        value={percentage}
                      />
                    </div>
                  </Col>
                )}
              </Row>
            </div>
          </CardBody>
        </Link>
      </Card>
    </LazyLoadComponent>
  )
}

const ProgressBar = ({ width }) => {
  const percentage = width ? `${width}%` : '0%'
  return (
    <>
      <div className={'mr-1 text-dark'}>{percentage}</div>
      <div
        style={{ backgroundColor: '#0FCF8D', height: 2, width: percentage }}
      ></div>
    </>
  )
}

const FallbackComp = (
  <div
    className='dFlex justifyCenter itemsCenter textCenter'
    style={{ minHeight: '70vh' }}
  >
    <Loader />
  </div>
)

const lang = {
  // 0: ['In Progress', <FaCheckCircle />],
  1: ['In Progress', <FaCheckCircle />],
  2: ['Failed', <FaExclamationCircle />],
  3: ['Needs manager approval', <FaUserCheck />],
  4: [
    'Certified',
    <FaCertificate />,
    // <div className="avatar bg-transparent progress-img">
    //   <img className="ml-2" title="Certified" src={Certified} alt="" />
    // </div>,
  ],
  6: ['Quiz Pending', <FaClock />],
}

function getStatusClass(status) {
  let classString = 'text-center align-items-center d-flex  '

  switch (status) {
    case 1:
      classString += 'bg-success'
      break
    case 2:
      classString += 'bg-failed'
      break
    case 3:
      classString += 'bg-approval'
      break
    case 4:
      classString += 'bg-certified'
      break
    case 6:
      classString += 'bg-quiz-pending'
      break
    default:
      classString += 'bg-normal'
      break
  }

  // switch (status) {
  //  case 0:
  //    classString += 'text-failed'
  //    break
  //  case 1:
  //    classString += 'text-dark'
  //    break
  //  case 2:
  //    classString += 'text-failed'
  //    break
  //  case 3:
  //    classString += 'text-approval'
  //    break
  //  case 4:
  //    classString += 'text-certified'
  //    break
  //  default:
  //    classString += 'text-normal'
  //    break
  // }

  return classString
}
